<template>
  <CModal
      :centered="true"
      :show.sync="studentAnswerViewModal"
      class="text-right"
      size="md"
      title="مشاهده پاسخ"
  >
    <div class="mb-3">
      <span class="bold">سوال:</span>{{ answer.question.text }}
    </div>
    <div v-if="filterQuestionVideos" class="flex-fill">
      <video class="media-video__wrapper" controls>
        <source v-if="answer.question.fileUrl" :src="answer.question.fileUrl"/>
      </video>
    </div>
    <div v-else-if="filterQuestionAudios" class="flex-fill">
      <audio class="media-audio__wrapper" controls>
        <source v-if="answer.question.fileUrl" :src="answer.question.fileUrl"/>
      </audio>
    </div>
    <div
        v-else-if="filterQuestionImages"
        class="media-image__wrapper flex-fill mx-2"
    >
      <img
          v-if="answer.question.fileUrl"
          :src="answer.question.fileUrl"
          alt=""
      />
    </div>

    <div v-else-if="answer.question.fileUrl" class="download-file ml-3 my-2">
      <a :href="answer.question.fileUrl" download="" target="_blank">
        <CIcon name="cil-file"/>
      </a>
    </div>

    <div class="my-3">
      <span class="bold">پاسخ سوال:</span>{{ answer.text }}
    </div>
    <div v-if="filterAnswerVideos" class="flex-fill">
      <video class="media-video__wrapper" controls>
        <source v-if="answer.fileUrl" :src="answer.fileUrl"/>
      </video>
    </div>
    <div v-else-if="filterAnswerAudios" class="flex-fill">
      <audio class="media-audio__wrapper" controls>
        <source v-if="answer.fileUrl" :src="answer.fileUrl"/>
      </audio>
    </div>
    <div
        v-else-if="filterAnswerImages"
        class="media-image__wrapper flex-fill mx-2"
    >
      <img v-if="answer.fileUrl" :src="answer.fileUrl" alt=""/>
    </div>

    <div v-else-if="answer.fileUrl" class="download-file ml-3 my-2">
      <a :href="answer.fileUrl" download="" target="_blank">
        <CIcon name="cil-file"/>
      </a>
    </div>
    <CInput
        v-model="mark"
        class="text-sm flex-fill mr-1 mt-3"
        label="نمره"
        type="number"
    />

    <template #footer>
      <CButton color="primary" @click="addStudentMark"> ثبت</CButton>
      <CButton color="danger" @click="studentAnswerViewModal = false">
        بستن
      </CButton>
    </template>
  </CModal>
</template>

<script>
import axios from "@/plugins/axios";

export default {
  props: {
    value: {
      type: Boolean,
    },
    answer: {
      type: Object,
    },
  },
  data() {
    return {
      mark: "",
      loading: false,
    };
  },
  computed: {
    studentAnswerViewModal: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },

    filterAnswerImages() {
      return this.answer.fileUrl
          ? this.answer.fileUrl.toLowerCase().includes("jpg")
          : "" || this.answer.fileUrl
              ? this.answer.fileUrl.toLowerCase().includes("png")
              : "" || this.answer.fileUrl
                  ? this.answer.fileUrl.toLowerCase().includes("jpeg")
                  : "" || this.answer.fileUrl
                      ? this.answer.fileUrl.toLowerCase().includes("bmp")
                      : "" || this.answer.fileUrl
                          ? this.answer.fileUrl.toLowerCase().includes("tiff")
                          : "" || this.answer.fileUrl
                              ? this.answer.fileUrl.toLowerCase().includes("gif")
                              : "" || this.answer.fileUrl
                                  ? this.answer.fileUrl.toLowerCase().includes("svg")
                                  : "";
    },
    filterAnswerVideos() {
      return this.answer.fileUrl
          ? this.answer.fileUrl.toLowerCase().includes("mp4")
          : "" || this.answer.fileUrl
              ? this.answer.fileUrl.toLowerCase().includes("mkv")
              : "" || this.answer.fileUrl
                  ? this.answer.fileUrl.toLowerCase().includes("avi")
                  : "" || this.answer.fileUrl
                      ? this.answer.fileUrl.toLowerCase().includes("mov")
                      : "" || this.answer.fileUrl
                          ? this.answer.fileUrl.toLowerCase().includes("webm")
                          : "" || this.answer.fileUrl
                              ? this.answer.fileUrl.toLowerCase().includes("flv")
                              : "";
    },
    filterAnswerAudios() {
      return this.answer.fileUrl
          ? this.answer.fileUrl.toLowerCase().includes("mp3")
          : "" || this.answer.fileUrl
              ? this.answer.fileUrl.toLowerCase().includes("ogg")
              : "" || this.answer.fileUrl
                  ? this.answer.fileUrl.toLowerCase().includes("m4a")
                  : "" || this.answer.fileUrl
                      ? this.answer.fileUrl.toLowerCase().includes("aac")
                      : "" || this.answer.fileUrl
                          ? this.answer.fileUrl.toLowerCase().includes("wav")
                          : "";
    },
    filterQuestionImages() {
      return this.answer.question.fileUrl
          ? this.answer.question.fileUrl.toLowerCase().includes("jpg")
          : "" || this.answer.question.fileUrl
              ? this.answer.question.fileUrl.toLowerCase().includes("png")
              : "" || this.answer.question.fileUrl
                  ? this.answer.question.fileUrl.toLowerCase().includes("jpeg")
                  : "" || this.answer.question.fileUrl
                      ? this.answer.question.fileUrl.toLowerCase().includes("bmp")
                      : "" || this.answer.question.fileUrl
                          ? this.answer.question.fileUrl.toLowerCase().includes("tiff")
                          : "" || this.answer.question.fileUrl
                              ? this.answer.question.fileUrl.toLowerCase().includes("gif")
                              : "" || this.answer.question.fileUrl
                                  ? this.answer.question.fileUrl.toLowerCase().includes("svg")
                                  : "";
    },
    filterQuestionVideos() {
      return this.answer.question.fileUrl
          ? this.answer.question.fileUrl.toLowerCase().includes("mp4")
          : "" || this.answer.question.fileUrl
              ? this.answer.question.fileUrl.toLowerCase().includes("mkv")
              : "" || this.answer.question.fileUrl
                  ? this.answer.question.fileUrl.toLowerCase().includes("avi")
                  : "" || this.answer.question.fileUrl
                      ? this.answer.question.fileUrl.toLowerCase().includes("mov")
                      : "" || this.answer.question.fileUrl
                          ? this.answer.question.fileUrl.toLowerCase().includes("webm")
                          : "" || this.answer.question.fileUrl
                              ? this.answer.question.fileUrl.toLowerCase().includes("flv")
                              : "";
    },
    filterQuestionAudios() {
      return this.answer.question.fileUrl
          ? this.answer.question.fileUrl.toLowerCase().includes("mp3")
          : "" || this.answer.question.fileUrl
              ? this.answer.question.fileUrl.toLowerCase().includes("ogg")
              : "" || this.answer.question.fileUrl
                  ? this.answer.question.fileUrl.toLowerCase().includes("m4a")
                  : "" || this.answer.question.fileUrl
                      ? this.answer.question.fileUrl.toLowerCase().includes("aac")
                      : "" || this.answer.question.fileUrl
                          ? this.answer.question.fileUrl.toLowerCase().includes("wav")
                          : "";
    },
  },
  watch: {
    studentAnswerViewModal(newValue) {
      if (newValue) this.mark = this.answer.mark;
    },
  },
  methods: {
    async addStudentMark() {
      try {
        this.loading = true;
        const {id: examId} = this.$route.params;
        const payload = {
          mark: this.mark,
        };
        await axios
            .put(`/exam/${examId}/answer/${this.answer.id}`, payload)
            .then((response) => {
              if (response.data.status === "ok")
                this.studentAnswerViewModal = false;
              this.$emit("get-answer");
            });
      } catch (error) {
        console.log("errrrrrror:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.download-file {
  display: inline-block;
  width: 65px;
  height: 65px;
  border: 1px solid #9da5b1;
  color: #9da5b1;
  text-align: center;
  line-height: 65px;
  cursor: pointer;

  border-radius: 8px;

  .c-icon {
    width: 2rem;
    height: 2rem;
  }
}

.desc {
  word-wrap: break-word;
  white-space: pre-line;
  font-size: 14px;
  line-height: 1.5;
}

.media-image__wrapper {
  position: relative;

  img {
    width: 100%;
    height: auto;
    object-fit: cover;
    border-radius: 8px;
    @media (max-width: 768px) {
      min-width: 100%;
      max-width: 100%;
    }
  }
}

.media-video__wrapper {
  position: relative;
  width: 100%;
  height: auto;
  border-radius: 8px;
}

.media-audio__wrapper {
  position: relative;
}
</style>